import { useQuery } from '@tanstack/react-query';
export const stubOrderData = [
    {
        _id: '1',
        order_id: 'ORD-2024-001',
        status: 'Booked',
        customer: 'ACME Corporation',
        origin: 'Los Angeles, CA',
        destination: 'Phoenix, AZ',
        total_revenue: 2500.00,
        total_cost: 1800.00,
        margin: 700.00,
        margin_percentage: 28.0,
        containers: ['MSKU1234567', 'MSKU2345678'],
        chassis: 'CH-4455-LA',
        vessel: 'MSC GULSUN',
        ocean_carrier: 'MSC',
        billing_status: 'invoiced',
    },
    {
        _id: '2',
        order_id: 'ORD-2024-002',
        status: 'Complete',
        customer: 'Global Logistics Inc',
        origin: 'Dallas, TX',
        destination: 'Atlanta, GA',
        total_revenue: 3200.00,
        total_cost: 2400.00,
        margin: 800.00,
        margin_percentage: 25.0,
        containers: ['COSCO9876543'],
        chassis: 'CH-7789-DX',
        vessel: 'COSCO SHIPPING UNIVERSE',
        ocean_carrier: 'COSCO',
        billing_status: 'audited',
    },
    {
        _id: '3',
        order_id: 'ORD-2024-003',
        status: 'Complete',
        customer: 'TechCorp Solutions',
        origin: 'Seattle, WA',
        destination: 'San Francisco, CA',
        total_revenue: 1800.00,
        total_cost: 1200.00,
        margin: 600.00,
        margin_percentage: 33.3,
        containers: ['EVRU5554321', 'EVRU6665432', 'EVRU7776543'],
        chassis: 'CH-1122-SEA',
        vessel: 'EVER GOLDEN',
        ocean_carrier: 'Evergreen',
        billing_status: 'awaiting_billable_event',
    },
    {
        _id: '4',
        order_id: 'ORD-2024-004',
        status: 'Booking',
        customer: 'Manufacturing Co',
        origin: 'Chicago, IL',
        destination: 'Detroit, MI',
        total_revenue: 4500.00,
        total_cost: 3600.00,
        margin: 900.00,
        margin_percentage: 20.0,
        containers: ['OOLU3338889'],
        chassis: 'CH-9988-CHI',
        vessel: 'OOCL HONG KONG',
        ocean_carrier: 'OOCL',
        billing_status: 'incomplete',
    },
    {
        _id: '5',
        order_id: 'ORD-2024-005',
        status: 'Canceled',
        customer: 'Retail Partners LLC',
        origin: 'Miami, FL',
        destination: 'Orlando, FL',
        total_revenue: 1200.00,
        total_cost: 950.00,
        margin: 250.00,
        margin_percentage: 20.8,
        containers: ['MAEU4447778', 'MAEU5558889'],
        chassis: 'CH-3344-MIA',
        vessel: 'MAERSK ESSEX',
        ocean_carrier: 'Maersk',
        billing_status: 'billing_hold',
    },
    {
        _id: '6',
        order_id: 'ORD-2024-006',
        status: 'Booked',
        customer: 'Supply Chain Solutions',
        origin: 'Houston, TX',
        destination: 'New Orleans, LA',
        total_revenue: 2800.00,
        total_cost: 2100.00,
        margin: 700.00,
        margin_percentage: 25.0,
        containers: ['CMAU9988776', 'CMAU1122334'],
        chassis: 'CH-5566-HOU',
        vessel: 'CMA CGM MARCO POLO',
        ocean_carrier: 'CMA CGM',
        billing_status: 'ready_to_bill',
    },
    {
        _id: '7',
        order_id: 'ORD-2024-007',
        status: 'Complete',
        customer: 'Logistics Express Inc',
        origin: 'Oakland, CA',
        destination: 'Las Vegas, NV',
        total_revenue: 1950.00,
        total_cost: 1400.00,
        margin: 550.00,
        margin_percentage: 28.2,
        containers: ['MSKU7788990'],
        chassis: 'CH-7788-OAK',
        vessel: 'MSC OSCAR',
        ocean_carrier: 'MSC',
        billing_status: 'supplemental_invoice',
    },
    {
        _id: '8',
        order_id: 'ORD-2024-008',
        status: 'Complete',
        customer: 'Metro Distribution Co',
        origin: 'Baltimore, MD',
        destination: 'Washington, DC',
        total_revenue: 1600.00,
        total_cost: 1200.00,
        margin: 400.00,
        margin_percentage: 25.0,
        containers: ['EVRU3344556', 'EVRU7788990', 'EVRU1122445'],
        chassis: 'CH-2233-BAL',
        vessel: 'EVER GLOBE',
        ocean_carrier: 'Evergreen',
        billing_status: 'template_billing',
    },
    {
        _id: '9',
        order_id: 'ORD-2024-009',
        status: 'Booking',
        customer: 'Industrial Freight LLC',
        origin: 'Portland, OR',
        destination: 'Sacramento, CA',
        total_revenue: 3600.00,
        total_cost: 2900.00,
        margin: 700.00,
        margin_percentage: 19.4,
        containers: ['OOLU8899001'],
        chassis: 'CH-9900-POR',
        vessel: 'OOCL BEIJING',
        ocean_carrier: 'OOCL',
        billing_status: 'customer_portal',
    },
    {
        _id: '10',
        order_id: 'ORD-2024-010',
        status: 'Booked',
        customer: 'Coastal Shipping Group',
        origin: 'Jacksonville, FL',
        destination: 'Savannah, GA',
        total_revenue: 2200.00,
        total_cost: 1650.00,
        margin: 550.00,
        margin_percentage: 25.0,
        containers: ['MAEU2233445', 'MAEU5566778'],
        chassis: 'CH-4455-JAX',
        vessel: 'MAERSK ALABAMA',
        ocean_carrier: 'Maersk',
        billing_status: 'pending_review',
    },
    {
        _id: '11',
        order_id: 'ORD-2024-011',
        status: 'Booking',
        customer: 'Northeast Transport',
        origin: 'Boston, MA',
        destination: 'Hartford, CT',
        total_revenue: 1750.00,
        total_cost: 1300.00,
        margin: 450.00,
        margin_percentage: 25.7,
        containers: ['COSCO5544332'],
        chassis: 'CH-6677-BOS',
        vessel: 'COSCO SHIPPING ARIES',
        ocean_carrier: 'COSCO',
        billing_status: 'invoiced',
    },
    {
        _id: '12',
        order_id: 'ORD-2024-012',
        status: 'Complete',
        customer: 'Midwest Cargo Services',
        origin: 'Minneapolis, MN',
        destination: 'Milwaukee, WI',
        total_revenue: 2400.00,
        total_cost: 1800.00,
        margin: 600.00,
        margin_percentage: 25.0,
        containers: ['CMAU9876543', 'CMAU1234567'],
        chassis: 'CH-8899-MIN',
        vessel: 'CMA CGM BENJAMIN FRANKLIN',
        ocean_carrier: 'CMA CGM',
        billing_status: 'audited',
    },
    {
        _id: '13',
        order_id: 'ORD-2024-013',
        status: 'Canceled',
        customer: 'Pacific Logistics Corp',
        origin: 'Long Beach, CA',
        destination: 'Phoenix, AZ',
        total_revenue: 2900.00,
        total_cost: 2400.00,
        margin: 500.00,
        margin_percentage: 17.2,
        containers: ['MSKU3344556'],
        chassis: 'CH-1122-LGB',
        vessel: 'MSC DANIELA',
        ocean_carrier: 'MSC',
        billing_status: 'incomplete',
    },
    {
        _id: '14',
        order_id: 'ORD-2024-014',
        status: 'Booked',
        customer: 'Southwest Distribution',
        origin: 'El Paso, TX',
        destination: 'Albuquerque, NM',
        total_revenue: 2100.00,
        total_cost: 1650.00,
        margin: 450.00,
        margin_percentage: 21.4,
        containers: ['EVRU5566778', 'EVRU9988001'],
        chassis: 'CH-5544-ELP',
        vessel: 'EVER LEGION',
        ocean_carrier: 'Evergreen',
        billing_status: 'awaiting_billable_event',
    },
    {
        _id: '15',
        order_id: 'ORD-2024-015',
        status: 'Complete',
        customer: 'Atlantic Freight Solutions',
        origin: 'Norfolk, VA',
        destination: 'Richmond, VA',
        total_revenue: 1800.00,
        total_cost: 1350.00,
        margin: 450.00,
        margin_percentage: 25.0,
        containers: ['OOLU2233445', 'OOLU5566778', 'OOLU8899001'],
        chassis: 'CH-3366-NOR',
        vessel: 'OOCL SHENZHEN',
        ocean_carrier: 'OOCL',
        billing_status: 'ready_to_bill',
    },
];
const fetchOrders = async () => {
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 2500));
    // TODO: Replace with actual API call
    // return fetch('/api/orders').then(res => res.json());
    return stubOrderData;
};
export const useOrderData = () => {
    const query = useQuery({
        queryKey: ['orders'],
        queryFn: fetchOrders,
        staleTime: 5 * 60 * 1000, // 5 minutes
        cacheTime: 10 * 60 * 1000, // 10 minutes
    });
    return query;
};
